import { useEffect, useState } from 'react';
import { AUTH_EVENTS, STORAGE_KEYS } from '@discover-frontend/auth';

import { isTrialUser } from 'src/utils/AuthHelperMethods';

/**
 * `isTrialUser` reads the JWT live, so the claim only goes stale because nothing
 * re-renders when the ID token is replaced mid-session. Recomputes on the two writes
 * that can swap it: this tab refreshing its own session, and another tab storing tokens.
 */
export const useIsTrialUser = (): boolean => {
  const [isTrial, setIsTrial] = useState(isTrialUser);

  useEffect(() => {
    const sync = () => setIsTrial(isTrialUser());

    // The cookie handoff clears tokens before writing them; ignore the empty step
    // so the claim does not flip false and back while a new session lands.
    const onStorage = (event: StorageEvent) => {
      if (event.key !== STORAGE_KEYS.ID_TOKEN || !event.newValue) return;
      sync();
    };

    window.addEventListener(AUTH_EVENTS.SESSION_RECOVERED, sync);
    window.addEventListener('storage', onStorage);

    return () => {
      window.removeEventListener(AUTH_EVENTS.SESSION_RECOVERED, sync);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return isTrial;
};
